import { inject, Injectable, computed } from '@angular/core';
import {
  BaseGridViewState,
  BASE_GRID_VIEW_STATE,
} from '@data-access/extendables';

import { WcgFilterIndicatorsOptions } from '@shared/interfaces/wcg-table-utils.interface';
import { LoadGridPayload, updateGridFilter } from '@data-access/shared';

import { UpdateUser, UserSignalState } from '../types';

@Injectable()
export class UserFacadeService extends BaseGridViewState {
  private readonly _userGridStore =
    inject<UserSignalState>(BASE_GRID_VIEW_STATE);

  readonly $users = computed(() => this._userGridStore.$users());

  readonly $currentUrl = computed(() => this._userGridStore.$currentUrl());

  readonly $isInternal = computed(() => this._userGridStore.$isInternal());

  readonly $userUpdated = computed(() => this._userGridStore.$userUpdated()); 

  readonly $updatedResult = computed(() => this._userGridStore.$updatedResult()); 

  constructor() {
    super();
  }

  updateUserGridFilter(filter: WcgFilterIndicatorsOptions) {
    const _constructFilter = updateGridFilter(
      filter,
      this._userGridStore.$advancedFilters(),
    );
    this.updateGrid(
      'filter',
      {
        filters: _constructFilter.filters,
        page: this._userGridStore.$pageView().page,
        pageSize: this._userGridStore.$pageView().pageSize,
      },
      true,
      false,
    );
  }

  updateUser(payload: UpdateUser, userId: string) {
    this._userGridStore.updateUser(payload, userId);
  }

  setURL(isInternal: boolean) {
    this._userGridStore.setURL(isInternal);
  }

  updateUserGrid(isInternal: boolean, params: LoadGridPayload) {
    this._userGridStore.updateUserGrid(isInternal,params);
  }
}
